import { defineComponent, useCssModule, ref, computed, provide, createElementBlock, openBlock, normalizeClass, unref, renderSlot, mergeModels, useSlots, useModel, inject, onMounted, onBeforeUnmount, watch, createElementVNode, createCommentVNode, toDisplayString, createVNode } from "vue";
import { createInjectionKey } from "../../utils/index.js";
import { _sfc_main as _sfc_main$2 } from "../WBadge/WBadge/index.js";
import "../WIcon/WIconStd/index.js";
import "../WIcon/WIconExt/index.js";
import './index.css';const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const accordionApiInjectionKey = createInjectionKey();
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "WAccordion",
  props: {
    size: { default: "sm" },
    variant: { default: "contrast" }
  },
  setup(__props) {
    const props = __props;
    const classes = useCssModule();
    const itemsRefs = ref([]);
    const expandedItem = ref(null);
    const api = {
      size: computed(() => props.size),
      variant: computed(() => props.variant),
      expandedItem,
      collapseItem,
      expandItem,
      registerItem,
      unregisterItem
    };
    provide(accordionApiInjectionKey, api);
    function collapseItem(item2) {
      if (expandedItem.value === item2) {
        expandedItem.value = null;
      }
    }
    function expandItem(item2) {
      expandedItem.value = item2;
    }
    function registerItem(item2) {
      itemsRefs.value.push(item2);
    }
    function unregisterItem(item2) {
      const index = itemsRefs.value.indexOf(item2);
      if (index !== -1) {
        itemsRefs.value.splice(index, 1);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass(unref(classes).accordion)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
const accordion = "WXvb1";
const style0$1 = {
  accordion
};
const cssModules$1 = {
  "$style": style0$1
};
const WAccordion = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__cssModules", cssModules$1]]);
const DATA_TEST = {
  ITEM: "w-accordion-item"
};
const _hoisted_1 = ["data-t"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WAccordionItem",
  props: /* @__PURE__ */ mergeModels({
    title: { default: void 0 }
  }, {
    "isExpanded": { default: false },
    "isExpandedModifiers": {}
  }),
  emits: ["update:isExpanded"],
  setup(__props, { expose: __expose }) {
    const slots = useSlots();
    const style = useCssModule();
    const classes = computed(() => [
      { [style.expanded]: isExpanded.value },
      style[`${(api == null ? void 0 : api.size.value) ?? "sm"}Size`],
      style[`${(api == null ? void 0 : api.variant.value) ?? "contrast"}Variant`],
      style.item
    ]);
    const itemRef = ref();
    const api = inject(accordionApiInjectionKey);
    const isExpanded = useModel(__props, "isExpanded");
    function toggle() {
      if (!itemRef.value) {
        return;
      }
      if (isExpanded.value) {
        api == null ? void 0 : api.collapseItem(itemRef.value);
      } else {
        api == null ? void 0 : api.expandItem(itemRef.value);
      }
    }
    function expand() {
      if (itemRef.value) {
        api == null ? void 0 : api.expandItem(itemRef.value);
      }
    }
    function collapse() {
      if (itemRef.value) {
        api == null ? void 0 : api.collapseItem(itemRef.value);
      }
    }
    __expose({
      toggle,
      isExpanded,
      expand,
      collapse
    });
    onMounted(() => {
      if (itemRef.value) {
        api == null ? void 0 : api.registerItem(itemRef.value);
      }
    });
    onBeforeUnmount(() => {
      if (itemRef.value) {
        api == null ? void 0 : api.unregisterItem(itemRef.value);
      }
    });
    watch(
      () => api == null ? void 0 : api.expandedItem.value,
      () => {
        isExpanded.value = (api == null ? void 0 : api.expandedItem.value) === itemRef.value;
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        class: normalizeClass(classes.value),
        "data-t": unref(DATA_TEST).ITEM,
        ref_key: "itemRef",
        ref: itemRef,
        tabindex: "0",
        onClick: toggle
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(style).header)
        }, [
          slots.headerLeft ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(style).headerLeft)
          }, [
            renderSlot(_ctx.$slots, "headerLeft", {
              isExpanded: isExpanded.value,
              toggle,
              expand,
              collapse
            })
          ], 2)) : createCommentVNode("", true),
          createElementVNode("h3", {
            class: normalizeClass(unref(style).title)
          }, toDisplayString(_ctx.title), 3),
          createElementVNode("div", {
            class: normalizeClass(unref(style).headerRight)
          }, [
            renderSlot(_ctx.$slots, "headerRight", {
              isExpanded: isExpanded.value,
              toggle,
              open: expand,
              close: collapse
            }, () => [
              createVNode(unref(_sfc_main$2), {
                name: isExpanded.value ? "outline-chevron-top" : "outline-chevron-bottom"
              }, null, 8, ["name"])
            ])
          ], 2)
        ], 2),
        createElementVNode("div", {
          role: "region",
          class: normalizeClass(unref(style).body)
        }, [
          createElementVNode("div", {
            class: normalizeClass(unref(style).bodyWrapper)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ], 2)
      ], 10, _hoisted_1);
    };
  }
});
const item = "-Xje4";
const header = "pgDFz";
const body = "_3mYel";
const bodyWrapper = "jj90m";
const title = "iMRob";
const headerLeft = "HdKhj";
const headerRight = "shjE1";
const smSize = "D7gze";
const xsSize = "ZOFDu";
const contrastVariant = "S3-ny";
const softVariant = "QEJUi";
const expanded = "CCTDs";
const style0 = {
  item,
  header,
  body,
  bodyWrapper,
  title,
  headerLeft,
  headerRight,
  "w-icon": "SfQgl",
  smSize,
  xsSize,
  contrastVariant,
  "--expanded": "vEafb",
  softVariant,
  expanded
};
const cssModules = {
  "$style": style0
};
const WAccordionItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  WAccordion,
  WAccordionItem,
  _export_sfc
};
